// extracted by mini-css-extract-plugin
module.exports = {"OrgUserListBase":"OrgUserList_OrgUserListBase__2D6DR"};